<template>
<div class="chapter">
<div class="inner_page">
<div class="chap">
<p class="chap-title"><a id="page_6"></a>Introduction</p>
</div>
<p class="noindentt">As an avid fan of appliqué I have always been intrigued with wool penny rugs and their construction and history. I was creating my own designs using raw-edged fabric and the blanket stitch when I was just 10 years old, and to this day it remains one of my favorite stitching methods.</p>
<p class="noindentt">Unlike many designs in felted wool today, my work is not primitive in design. Coming from a formal appliqué background, I use matching wool threads and dimensional appliqué methods, and I embellish my work with embroidery. As a result, my designs are sophisticated and dimensional and offer clarity to their subject, making them quite distinctive.</p>
<p class="noindentt">The organic and forgiving nature of felted wool allows me to sculpt my table rugs and home fashion accessories, bringing a lush, colorful accent to any room. My needle-slanting technique and methods for marking embroidery guides will appeal to the embroiderer, the quilter, and any lover of hand sewing.</p>
<p class="noindentt">The projects in this book are functional, are quick to stitch, and make wonderful gifts. The patterns include both small and large projects that can be completed on vacation, while traveling, in between larger projects, or as quick gifts for friends.</p>
<p class="noindentt">My inspiration for these designs comes from a variety of subjects, and I have included them so that you, too, may begin to think about what appeals to you designwise in the world and then translate those things into sculpted wool creations of your own.</p>
<p class="fm-left1">Happy stitching!</p>
<p class="fm-leftt"><i>—Deborah Gale Tirico</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_introduction.vue?332d7176